import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'

import { ExpandableText, Heading } from '../../common'

export type Props = Pick<TRoomDetail, 'usageGuide'>

export const MobileUsageGuide = ({ usageGuide }: Props) => {
  const t = useTranslations('room_detail')

  return (
    <section className="space-y-4">
      <Heading size="small">{t('unit_guide.title')}</Heading>
      <ExpandableText
        content={usageGuide}
        lineClamp={10}
        className="typo-body2"
      />
    </section>
  )
}
